/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeedbackResponse } from '../models/FeedbackResponse';
import type { SendFeedbackRequest } from '../models/SendFeedbackRequest';
import type { Unit } from '../models/Unit';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FeedbackControllerService {
    /**
     * @returns FeedbackResponse OK
     * @throws ApiError
     */
    public static getFeedbacks(): CancelablePromise<Array<FeedbackResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feedback',
        });
    }
    /**
     * @param requestBody
     * @returns Unit OK
     * @throws ApiError
     */
    public static sendFeedback(
        requestBody: SendFeedbackRequest,
    ): CancelablePromise<Unit> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/feedback',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
